import styled from 'styled-components';
import { Panel } from 'primereact/panel';
import { useQuery } from 'react-query';
import { getVersion } from '../services/version';
import { version as primereactVersion } from 'primereact/package.json';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  height: 100vh;
`;

const InfoGrid = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
`;

function VersionPage() {
  const { data } = useQuery('getVersion', getVersion);

  return (
    <Wrapper>
      <Panel header={APP_NAME}>
        <InfoGrid>
          <em>App version</em>
          {APP_VERSION}
          <em>Commit hash</em>
          {COMMIT_HASH}
          <em>API Commit hash</em>
          {data?.gitHash}
          <em>Primereact version</em>
          {primereactVersion}
        </InfoGrid>
      </Panel>
    </Wrapper>
  );
}

export default VersionPage;
